import { render, staticRenderFns } from "./Type_Setting.vue?vue&type=template&id=302ab59b&"
import script from "./Type_Setting.vue?vue&type=script&lang=js&"
export * from "./Type_Setting.vue?vue&type=script&lang=js&"
import style0 from "./Type_Setting.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports